import LocalizedStrings from "react-localization";

export const mappingFilterModalStrings = new LocalizedStrings({
  en: {
    filterButton: "Filter",
    title: "Filters",
    productId: "Product ID",
    productLabel: "Product Label",
    advertiserId: "Advertiser ID",
    advertiserLabel: "Advertiser Label",
    socialAccountName: "Social account name",
    socialAccountFriendlyName: "Social account friendly name",
    threshold: "Threshold",
    thresholdNone: "Everything",
    belowThreshold: "Below Threshold",
    aboveThreshold: "Above Threshold",
    cancel: "Cancel",
    applyFilters: "Apply filters",
  },
  fr: {
    filterButton: "Filtrer",
    title: "Filtres",
    productId: "ID produit",
    productLabel: "Libellé produit",
    advertiserId: "ID annonceur",
    advertiserLabel: "Libellé annonceur",
    socialAccountName: "Social account name",
    socialAccountFriendlyName: "Social account friendly name",
    threshold: "Seuil d'investissement ",
    thresholdNone: "Tout",
    belowThreshold: "En dessous du seuil",
    aboveThreshold: "Au-dessus du seuil",
    cancel: "Annuler",
    applyFilters: "Appliquer les filtres",
  },
});
